import { Injectable } from '@angular/core';
import { switchMap } from 'rxjs/operators';
import { ICommonResponse } from '../../../interfaces/icommon-response';
import { GridService } from '../../../shared-services/grid/grid.service';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export abstract class RealtyService {

  constructor(protected http: HttpClient, protected gridService: GridService) {}

  abstract prepareCondition(conditions: Record<string, any>, searchForm: any, formData: any): Observable<Record<string, any>>;

  protected getDataByGrid(
    url: string,
    offset = 0,
    limit = 10,
    searchForm?: any,
    sortParams?: any
  ) {
    const conditions: Record<string, any> = {};
    const formData: any = {};

    if (typeof sortParams !== 'object') {
      sortParams = {};
    }

    return this.prepareCondition(conditions, searchForm, formData).pipe(
      switchMap((conditions) => {
        const query = this.gridService.createGetFilter(formData, conditions, String(offset), String(limit), sortParams, false);

        return this.http.get<ICommonResponse>(url + '?' + query);
      }),
    );
  }
}
